exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inputVcDemo[data-v-58daa298]{max-width:100%}.inputVcDemo .demo-item[data-v-58daa298]{width:600px;margin:10px 0;max-width:100%}.inputVcDemo .demo-item .demo-btn[data-v-58daa298]{margin-right:15px;margin-bottom:10px}.inputVcDemo .demo-item2[data-v-58daa298]{margin:10px 0}.inputVcDemo p[data-v-58daa298]{color:#066}.inputVcDemo .demoText[data-v-58daa298]{margin:15px 10px 5px}", ""]);

// exports
